import {Children, ReactElement, ReactNode} from "react";
import {useLocation} from "react-router";

import {Accordion} from "@/components/accordion/Accordion.tsx";
import {AccordionItemProps} from "@/components/accordion/subComponents/AccordionItem/AccordionItem.types.ts";
import {NavBarAccordionItem} from "@/components/navBar/subComponents/NavBarAccordion/NavBarAccordionItem.tsx";
import {Nullable} from "@/lib/typeUtils.ts";

// This component wraps the NavBarAccordionItem with an Accordion and sets the default open item based on the current page.
// This looks for all NavBarAccordionItem children and checks the navlinks within that accordion item for any `to` prop
//  if that to prop matches the current page we set the default open accordion to its parent to ensure the link is visible.
export const NavBarNavItemsAccordionWrapper = ({
  children,
  className,
}: {
  children: Nullable<ReactElement<AccordionItemProps>> | Nullable<ReactElement<AccordionItemProps>>[];
  className?: string;
}) => {
  const {pathname: currentPage} = useLocation();
  const defaultOpen = Children.toArray(children).find((child: ReactNode) => {
    if ((child as ReactElement)?.type === NavBarAccordionItem) {
      const childProps = (child as ReactElement).props;
      return (
        Children.toArray(childProps.children).some((subChild) => {
          const subChildProps = (subChild as ReactElement).props;
          return subChildProps.to && subChildProps.to === currentPage;
        }) ||
        (childProps.specialCasePages?.some((pattern: string) => new RegExp(pattern).test(currentPage)) ?? false)
      );
    }
  });

  return (
    <Accordion
      className={className}
      defaultActiveKey={(defaultOpen as ReactElement<typeof NavBarAccordionItem>)?.props.name}
      as={"ul"}
    >
      {children}
    </Accordion>
  );
};
